import React from "react";
import { ShieldCheck } from "lucide-react";

const Privacy = () => (
  <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow mt-0 sm:mt-8 mb-0 sm:mb-8">
    <div className="flex items-center gap-2 mb-4">
      <ShieldCheck className="text-green-600 w-7 h-7" />
      <h1 className="text-2xl font-bold text-gray-800">Privacyverklaring</h1>
    </div>
    <p className="mb-4 text-gray-700">
      Wij hechten veel waarde aan de bescherming van jouw persoonsgegevens. In deze privacyverklaring leggen wij uit welke gegevens wij verzamelen, waarom wij dat doen en wat jouw rechten zijn.
    </p>
    <h2 className="text-lg font-semibold mt-6 mb-2">Welke gegevens verzamelen wij?</h2>
    <ul className="list-disc ml-6 text-gray-700 mb-4">
      <li>Je naam (zoals je die zelf invult)</li>
      <li>Bestelgegevens (zoals producten en aantallen)</li>
      <li>Technische gegevens zoals IP-adres en browserinformatie (voor beveiliging en statistieken)</li>
    </ul>
    <h2 className="text-lg font-semibold mt-6 mb-2">Waarom verzamelen wij deze gegevens?</h2>
    <ul className="list-disc ml-6 text-gray-700 mb-4">
      <li>Om bestellingen te kunnen verwerken en tonen in de app</li>
      <li>Om de werking en veiligheid van de app te waarborgen</li>
      <li>Voor statistische doeleinden en verbetering van de dienst</li>
    </ul>
    <h2 className="text-lg font-semibold mt-6 mb-2">Met wie delen wij jouw gegevens?</h2>
    <p className="mb-4 text-gray-700">
      Jouw gegevens worden niet gedeeld met derden, tenzij dit noodzakelijk is voor de werking van de app of wettelijk verplicht is.
    </p>
    <h2 className="text-lg font-semibold mt-6 mb-2">Hoe lang bewaren wij jouw gegevens?</h2>
    <p className="mb-4 text-gray-700">
      Wij bewaren jouw gegevens niet langer dan nodig is voor het doel waarvoor ze zijn verzameld. Je kunt altijd verzoeken om je gegevens te laten verwijderen.
    </p>
    <h2 className="text-lg font-semibold mt-6 mb-2">Jouw rechten</h2>
    <ul className="list-disc ml-6 text-gray-700 mb-4">
      <li>Recht op inzage, correctie en verwijdering van je gegevens</li>
      <li>Recht om bezwaar te maken tegen het gebruik van je gegevens</li>
      <li>Recht op overdraagbaarheid van je gegevens</li>
    </ul>
    <p className="mb-4 text-gray-700">
      Wil je gebruik maken van deze rechten of heb je vragen? Neem dan contact op via het contactformulier in de app.
    </p>
    <h2 className="text-lg font-semibold mt-6 mb-2">Contact</h2>
    <p className="text-gray-700">
      Voor vragen over privacy kun je contact opnemen met de beheerder van deze app.
    </p>
    <footer className="mt-10 pt-6 border-t border-gray-200 flex flex-col items-center gap-2 text-xs text-gray-400">
      <span>&copy; {new Date().getFullYear()} Frieten bestellen</span>
      <span>Privacyverklaring &middot; Laatste update: juli 2025</span>
    </footer>
  </div>
);

export default Privacy;
